<template>
  <el-dialog
    top="10vh"
    width="1200px"
    :title="'【' + orderInfo.sn + '】' + $t('vipModule.orderDetailTitle')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @close="closeDetail">
    <div class="content" v-loading="fetchLoading">
      <el-collapse v-model="openList">
        <el-collapse-item name="storeInfo">
          <template slot="title">
            <div class="title-text">
              <span class="title-item">{{ $t('vipModule.orderDetailGoodsInfoTitle') }}</span>
              <span style="color: #000" class="title-item">{{ $t('vipModule.orderDetailTotalItemsLabel') }}{{initCount}}{{ $t('vipModule.orderDetailUnitPieceLabel') }}</span>
            </div>
          </template>
          <div>
            <grid-manager :option="gridOption"></grid-manager>
          </div>
        </el-collapse-item>

        <el-collapse-item name="orderInfo" v-if="detailData.orderInfo">
          <template slot="title">
            <div>
              <span class="title-text">{{ $t('vipModule.orderDetailOrderInfoTitle') }}</span>
            </div>
          </template>
          <div class="order-info">
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailTotalAmountLabel') }}</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailRetailAmountLabel') }}</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailReceivedAmountLabel') }}</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.discountAmount">
              <span class="order-info-label">{{ $t('vipModule.orderDetailActivityAmountLabel') }}</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.changePrice">
              <span class="order-info-label">{{ $t('vipModule.orderDetailChangeAmountLabel') }}</span>
              <span class="red-text">***</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailSaleStatusLabel') }}</span>
              <span v-if="detailData.orderInfo.state === '-1'">{{ $t('vipModule.orderDetailStatusCanceled') }}</span>
              <span v-if="detailData.orderInfo.state === '1'">{{ $t('vipModule.orderDetailStatusPendingPayment') }}</span>
              <span v-if="detailData.orderInfo.state === '2'">{{ $t('vipModule.orderDetailStatusPaying') }}</span>
              <span v-if="detailData.orderInfo.state === '3'">{{ $t('vipModule.orderDetailStatusPaid') }}</span>
              <span v-if="detailData.orderInfo.state === '4'">{{ $t('vipModule.orderDetailStatusPendingApproval') }}</span>
              <span v-if="detailData.orderInfo.state === '5'">{{ $t('vipModule.orderDetailStatusInvalid') }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailStoreNameLabel') }}</span>
              <span>{{ detailData.orderInfo.deptName }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.giftDetail">
              <span class="order-info-label">{{ $t('vipModule.orderDetailGiftInfoLabel') }}</span>
              <span>{{ detailData.orderInfo.giftDetail }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailSourceLabel') }}</span>
              <span>{{ detailData.orderInfo.source === '1' ? $t('vipModule.orderDetailSourceMobile') : $t('vipModule.orderDetailSourceClient') }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailOrderTypeLabel') }}</span>
              <span>{{ detailData.orderInfo.orderTypeTitle }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailSaleNoLabel') }}</span>
              <span>{{ detailData.orderInfo.orderNo }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.originalInnerSn">
              <span class="order-info-label">{{ $t('vipModule.orderDetailOriginalSaleNoLabel') }}</span>
              <span>{{ detailData.orderInfo.originalInnerSn }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailOuterNoLabel') }}</span>
              <span>{{ detailData.orderInfo.outerSn }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailPerformanceMethodLabel') }}</span>
              <span>{{detailData.orderInfo.brokerage == 1 ? $t('vipModule.orderDetailPerformancePersonal') : detailData.orderInfo.brokerage == 2 ? $t('vipModule.orderDetailPerformanceTeam') : detailData.orderInfo.brokerage == 3 ? $t('vipModule.orderDetailPerformanceDistribution') : ''}}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.brokerage == 1 && detailData.orderInfo.shoppingGuideName">
              <span class="order-info-label">{{ $t('vipModule.orderDetailSalesmanLabel') }}</span>
              <span>{{ detailData.orderInfo.shoppingGuideName }}</span>
            </div>
            <div class="order-info-item">
              <span class="order-info-label">{{ $t('vipModule.orderDetailCreateTimeLabel') }}</span>
              <span>{{ detailData.orderInfo.createTime }}</span>
            </div>
            <div v-if="detailData.orderInfo.brokerage == 2 && detailData.orderInfo.shoppingGuideName" class="row" style="line-height: 20px; margin-top: 5px; width: 100%">
              <span class="order-info-label">{{ $t('vipModule.orderDetailTeamMembersLabel') }}</span>
              <span class="description">{{ detailData.orderInfo.shoppingGuideName }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.createTerminalTitle">
              <span class="order-info-label">{{ $t('vipModule.orderDetailCreateTerminalLabel') }}</span>
              <span>{{ detailData.orderInfo.createTerminalTitle }}</span>
            </div>
            <div class="order-info-item" v-if="detailData.orderInfo.endTerminalTitle">
              <span class="order-info-label">{{ $t('vipModule.orderDetailEndTerminalLabel') }}</span>
              <span>{{ detailData.orderInfo.endTerminalTitle }}</span>
            </div>
          </div>
        </el-collapse-item>

        <el-collapse-item name="promotionInfo" v-if="detailData.promotionInfo && detailData.promotionInfo.length">
          <template slot="title">
            <div>
              <span class="title-text">{{ $t('vipModule.orderDetailPromotionInfoTitle') }}</span>
            </div>
          </template>
          <template v-if="detailData.promotionInfo">
            <el-table
              border
              :data="detailData.promotionInfo"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="name" :label="$t('vipModule.orderDetailPromotionNameLabel')"></el-table-column>
              <el-table-column prop="type" :label="$t('vipModule.orderDetailPromotionTypeLabel')"></el-table-column>
              <el-table-column prop="activityNo" :label="$t('vipModule.orderDetailPromotionNoLabel')"></el-table-column>
              <el-table-column prop="discountAmount" :label="$t('vipModule.orderDetailPromotionDiscountAmountLabel')">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="paymentState" :label="$t('vipModule.orderDetailPromotionDetailLabel')">
                <template slot-scope="scope">
                  <el-button type="text" @click="showDetail(scope.row)">{{ $t('vipModule.orderDetailViewDetailBtn') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-collapse-item>

        <el-collapse-item name="paymentInfo" v-if="(detailData.paymentInfo && detailData.paymentInfo.length) || (detailData.couponInfoList && detailData.couponInfoList.length)">
          <template slot="title">
            <div>
              <span class="title-text">{{ $t('vipModule.orderDetailPaymentInfoTitle') }}</span>
            </div>
          </template>
          <div>
            <el-table
              border
              :data="detailData.paymentInfo"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="paymentName" :label="$t('vipModule.orderDetailPaymentMethodLabel')"></el-table-column>
              <el-table-column prop="paymentPrice" :label="$t('vipModule.orderDetailPaymentAmountLabel')">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="paymentState" :label="$t('vipModule.orderDetailPaymentStatusLabel')">
                <template slot-scope="scope">
                  <el-tag
                    size="small"
                    effect="dark"
                    :type="
                      scope.row.paymentState == 0
                        ? 'primary'
                        : scope.row.paymentState == 1
                        ? 'success'
                        : scope.row.paymentState == 2
                        ? 'info'
                        : scope.row.paymentState == 3
                        ? 'danger'
                        : ''
                    ">
                    {{
                      scope.row.paymentState == 0
                        ? $t('vipModule.orderDetailPaymentStatusCreated')
                        : scope.row.paymentState == 1
                        ? $t('vipModule.orderDetailPaymentStatusPaid')
                        : scope.row.paymentState == 2
                        ? $t('vipModule.orderDetailPaymentStatusCanceled')
                        : scope.row.paymentState == 3
                        ? $t('vipModule.orderDetailPaymentStatusPaying')
                        : ''
                    }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('vipModule.orderDetailCreateTimeLabel')" width="180"></el-table-column>
              <el-table-column prop="updateTime" :label="$t('vipModule.orderDetailUpdateTimeLabel')"></el-table-column>
              <el-table-column prop="outerNo" :label="$t('vipModule.orderDetailPaymentVoucherNoLabel')"></el-table-column>
              <el-table-column prop="serialNumber" :label="$t('vipModule.orderDetailPaymentSerialNoLabel')"></el-table-column>
            </el-table>
            <el-table
              v-if="detailData.couponInfoList && detailData.couponInfoList.length"
              border
              style="margin-top: 10px;"
              :data="detailData.couponInfoList"
              :header-cell-style="{background: '#FAFAFA', color: '#436481'}">
              <el-table-column prop="name" :label="$t('vipModule.orderDetailCouponNameLabel')"></el-table-column>
              <el-table-column prop="couponTypeName" :label="$t('vipModule.orderDetailCouponTypeLabel')" width="180"></el-table-column>
              <el-table-column prop="channelName" :label="$t('vipModule.orderDetailCouponSourceLabel')"></el-table-column>
              <el-table-column prop="actualDiscountAmount" :label="$t('vipModule.orderDetailCouponAmountLabel')">
                <template slot-scope="scope">
                  <div style="color: #F8475F;">***</div>
                </template>
              </el-table-column>
              <el-table-column prop="detail" :label="$t('vipModule.orderDetailTableOperationLabel')">
                <template slot-scope="scope">
                  <div style="color: #077cf2; cursor: pointer" @click="detailOpen(scope.row)">
                    {{ $t('vipModule.orderDetailViewDetailBtn') }}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <ActiveDetail v-if="activeVisible" :promotionObj="propsData" @close="activeVisible = false"></ActiveDetail>
    <CouponDetail v-if="couponVisible" :dataInfo="propsData" @close="couponVisible = false"></CouponDetail>
  </el-dialog>
</template>

<script>
import {queryInvoicesInfo} from "@/libs/http/modules/posOrder"
import ActiveDetail from "./activeDetail.vue"
import CouponDetail from "./couponDetail.vue"
export default {
  name: 'orderDetail',
  components: {
    ActiveDetail,
    CouponDetail
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => null
    }
  },
  data(){
    return {
      dialogVisible: true,
      fetchLoading: false,
      openList: ['storeInfo', 'orderInfo', 'promotionInfo', 'paymentInfo'],
      detailData: {},
      propsData: null,
      initCount: '',
      activeVisible: false,
      couponVisible: false,
      sell: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/sell.png") : require("@/assets/images/vnSell.png"),
      give: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/give.png") : require("@/assets/images/vnGave.png"),
      back: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/return.png") : require("@/assets/images/vnReturn.png"),
      rite: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/rite.png") : require("@/assets/images/vnGift.png"),
      ned: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/ned.png") : require("@/assets/images/vnChange.png"),
      gridOption: {
        gridManagerName: 'goosInfo',
        firstLoading: false,
        height: 'auto',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: false,
        supportConfig: true,
        disableAutoLoading: true,
        supportMenu: false,
        disableBorder: true,
        disableLine: true,
        columnData: [
          {
            key: 'goodsNature',
            text: this.$t('gridManage.columnType'),
            align: 'center',
            width: '70px',
            template: () => {
              return `
                <div>
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '1'" :src="sell" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '2'" :src="give" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '4'" :src="back" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '3'" :src="rite" />
                    <img style="width:40px;height:40px;" v-if="row.goodsNature === '6'" :src="ned" />
                </div>
              `
            }
          },
          {
            key: 'goodsName',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '350px',
            template: () => {
              return `
                <div class="row align-cneter" style="text-align:left;">
                <div style="position:relative;overflow:hidden;width:102px;height:92px;border-radius:4px;">
                    <el-image v-if="row.goodsImg && row.goodsImg[0]" style="width:102px;height:92px;border-radius:4px;float:left;" :preview-src-list="row.goodsImg" :src="row.goodsImg[0]"></el-image>
                    <div v-else style="width:102px;height:92px;border-radius:4px;text-align:center;line-height:92px;color:#999;background:#f5f5f5;">{{$t('gridManage.noGoodsImage')}}</div>
                    <div v-if="row.promoteActivityId || row.goodsNature === '2' || row.isAdd === 1 || row.dataType === 'other' || row.couponType"
                      style="width:70px;height:22px;line-height:22px;position:absolute;top:4px;right:-19px;transform: rotate(45deg);text-align:center;color:#fff;"
                      :style="row.isAdd === 1 ? 'background: linear-gradient(0deg, rgb(116,47,169), rgb(101,41,147), rgb(72,30,105))' : row.goodsNature === '2' ? 'background: linear-gradient(0deg, #208AEC, #02D7F0, #00C6F7)' : 'background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400)'">
                      <span>{{row.isAdd === 1 ? $t('gridManage.addBuy') : row.goodsNature === '2' ? $t('gridManage.gave') : row.promoteActivityId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}</span>
                  </div>
                </div>
                <div class="column space-center" style="margin-left:10px;flex:1;width:170px;">
                    <div style="font-size:18px;color:#333;margin-top:-4px;">{{row.goodsName}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;" v-if="row.dataType !== 'other'" >{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                    <div style="font-size:14px;color:#999;" v-if="row.dataType !== 'other'" >{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                    <div style="font-size:14px;color:#999;margin:4px 0;" v-else >{{$t('gridManage.goodsNo')}}：{{row.couponTypeDesc}}</div>
                </div>
                </div>
              `
            }
          },
          {
            key: 'colorDesc',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
                <div v-if="row.attrList" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;color:#333;line-height:26px;border-radius:2px;cursor:pointer;">
                  <p v-for="(item, index) in row.attrList.slice(0,2)" :key="item.code" style="">{{item.value}}
                      <span v-if="index == 0" style="margin:0 3px;">,</span>
                  </p>
                </div>
              `
            }
          },
          {
            key: 'number',
            text: this.$t('gridManage.number'),
            align: 'center',
            width: '100px',
            template: () => {
              return `
                <div style="font-size:20px;">{{row.number}}</div>
              `
            }
          },
          {
            key: 'tagPrice',
            text: this.$t('gridManage.tagPrice'),
            width: '120px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.tagPrice" style="font-size:20px;">{{row.tagPrice}}đ</span>
                </div>
              `
            }
          },
          {
            key: 'sellPrice',
            text: this.$t('gridManage.retailPrice'),
            width: '120px',
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.sellPrice" style="font-size:20px;">***</span>
                </div>
              `
            }
          },
          {
            key: 'unitRealPrice',
            text: this.$t('gridManage.realPriceUnit'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-center space-center">
                  <span v-if="row.unitRealPrice" style="color:#666;font-size:20px;">***</span>
                </div>
              `
            }
          },
          {
            key: 'totalRealPrice',
            text: this.$t('gridManage.totalPrice'),
            align: 'center',
            template: () => {
              return `
                <div class="row align-cneter space-center" style="color:#F8475F;font-size:20px;">***</div>
              `
            }
          }
        ],
        ajaxData: this.showGoodsTable
      },
    }
  },
  created() {
    this.queryDetail()
  },
  methods: {
    closeDetail(){
      this.dialogVisible = false
      this.$emit('close')
    },
    queryDetail(){
      this.fetchLoading = true
      queryInvoicesInfo({
        orderId: this.orderInfo.id
      }).then(data => {
        this.detailData = data
        this.fetchLoading = false
        if (this.detailData.couponInfoList && this.detailData.couponInfoList.length) {
          let list = []
          this.detailData.couponInfoList.forEach(item => {
            if([1, 2].includes(item.couponType)) {
              list.push({
                goodsNature: '1',
                dataType: 'other',
                couponType: item.couponType,
                goodsName: item.couponTypeName,
                couponTypeDesc: item.name,
                goodsNo: item.name,
                number: item.number,
                tagPrice: item.tagPrice,
                sellPrice: item.sellPrice,
                unitRealPrice: item.retailPrice,
                certificateId: item.certificateId,
                couponInfoId: item.couponInfoId,
                totalRealPrice: item.totalRealPrice
              })
            }
          })
          this.detailData.storeInfo = this.detailData.storeInfo.concat(list)
        }
        GridManager.refreshGrid(this.gridOption.gridManagerName)
      }).catch(error => {
        this.fetchLoading = false
        this.$message({type: 'error', message: error, duration: 2000, showClose: true})
      })
    },
    showGoodsTable() {
      if (this.detailData.storeInfo && this.detailData.storeInfo.length) {
        this.initCount = this.detailData.storeInfo.reduce((prev, cur) => {
          return prev + Number(cur.number)
        }, 0)
        return new Promise((resolve, reject) => {
          const tableData = {
            data: this.detailData.storeInfo
          }
          resolve(tableData)
        })
      }
    },
    showDetail(data) {
      this.propsData = {
        ...data,
        orderId: this.orderInfo.id
      }
      this.activeVisible = true
    },
    detailOpen(data) {
      this.propsData = data
      this.couponVisible = true
    },
  }
}
</script>

<style lang="scss" scoped>
.content{
  height: 66vh;
  overflow: auto;
  margin: -20px 0 -30px;
  .title-text {
    padding-left: 10px;
    border-left: 4px solid #067cf2;
    font-size: 16px;
    height: 20px;
    display: flex;
    align-items: center;
    .title-item {
      margin-right: 10px;
    }
  }
  .order-info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    .order-info-item {
      width: 33%;
    }
    .order-info-label {
      width: 70px;
      color: #999;
    }
    .red-text {
      color: red;
      font-size: 18px;
    }
  }
}
</style>